export default "__VITE_ASSET__893b3dc3__"